import type { location } from "./location";

export interface zone {
    id: string;
    accountId: number;
    zoneId: number;
    name: string;
    geofence: string;
    fee: number;
    minAmount?: number;
    freeMin?: number;
}

export interface Zone extends zone {
    locations: location[];
}

export const parsePolygon = (geometry: string): LatLng[] => {
    let coordinates: [number, number][] = [];
    if (geometry) {
        const coordStr = geometry.replace(/,\s/g, ",").replace("((", "").replace("))", "");
        const coordsArray = coordStr.split("),(");
        coordinates = coordsArray.map(x => x.split(",").map(y => Number.parseFloat(y))) as any;
    }
    return coordinates.map(([lng, lat]) => ({ lat, lng }));
};

export const polygonToString = (geometry: LatLng[][]): string => {
    return `(${geometry[0]
        .map(({ lng, lat  }) => `(${lng},${lat})`)
        .join(",")})`;
};

type LatLng = { lat: number; lng: number };